import { IAPPlannerResourceTab } from './../builders/planner_resource_tab_builder';
export const PlannerResourceMAPTab: IAPPlannerResourceTab = {
  title: 'Plan Suggestions',
  icon: 'book_with_watch',
  active: true,
  showOnViewMode: true,
  key: 'MAP'
};

export const PlannerResourceFavoriteTab: IAPPlannerResourceTab = {
  title: 'Favorites',
  icon: 'heart',
  active: false,
  showOnViewMode: false,
  key: 'FAVORITE'
};

export const PlannerResourceSearchTab: IAPPlannerResourceTab = {
  title: 'Search',
  icon: 'search',
  active: false,
  showOnViewMode: false,
  key: 'SEARCH'
};

export const PlannerScheduleAppointmentTab: IAPPlannerResourceTab = {
  title: 'Schedule an Appointment',
  icon: 'user',
  active: false,
  showOnViewMode: false,
  external: true,
  key: 'SCHEDULE_APPOINTMENT'
};

export const PlannerResourceTabs = [
  PlannerResourceMAPTab,
  PlannerResourceFavoriteTab,
  PlannerResourceSearchTab,
  PlannerScheduleAppointmentTab
];



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_resources/constants/planner_resource_tabs.ts